<template>
  <v-navigation-drawer app dark>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="white" size="40">
            <v-icon color="grey darken-4">mdi-book-open-page-variant</v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-title class="white--text">ヘルプ</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-for="item in items" :key="item.text" :to="{ path: item.link }">
        <v-list-item-icon v-on="on">
            <v-icon color="white">{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="white--text">{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "HelpGlobalSidebar",
  data: () => ({
    items: [
      // { icon: "mdi-view-dashboard-variant", text: "ダッシュボード", link: "/help/dashboard" },
      { icon: "mdi-account", text: "ユーザー情報", link: "/help/user" },
      { icon: "mdi-office-building", text: "部署情報", link: "/help/department" },
      { icon: "mdi-account-tie", text: "取引先情報", link: "/help/suppliers" },
      { icon: "mdi-file-tree", text: "費目テンプレート情報", link: "/help/template" },
      { icon: "mdi-focus-field-horizontal", text: "費目情報", link: "/help/expense" },
      { icon: "mdi-expand-all", text: "集計費目情報", link: "/help/aggregate" },
      { icon: "mdi-check-decagram", text: "権限情報", link: "/help/permission" },
      { icon: "mdi-calendar-edit", text: "工事情報", link: "/help/construction" },
      { icon: "mdi-file-edit", text: "作業日報", link: "/help/report/daily/worker" },
      { icon: "mdi-file-document-box-check-outline", text: "工事日報", link: "/help/report/daily/construction" },
      { icon: "mdi-tools", text: "企業情報", link: "/help/client" },
      { icon: "mdi-cogs", text: "プロフィール", link: "/help/profile" },
    ]
  })
};
</script>
